import Bar from './bar.component';

interface TopBarProps {
  title: string;
}

function TopBar( { title }: TopBarProps ) {
  return (
    <div className="flex-center py-3">
      <div className="flex items-center w-full">
        <span className="font-comfortaa text-3xl mr-4">{ title }</span>
        <Bar />
      </div>
    </div>
  );
}

export default TopBar;
